/**
 * Normalises a person name for UI display: each word segment is title-cased (first letter uppercase, rest lowercase).
 * Handles ALL-CAPS inputs and hyphenated parts (e.g. "MARY-JANE SMITH" → "Mary-Jane Smith").
 */
export function formatPersonName(input: string | null | undefined): string {
  const s = typeof input === "string" ? input.trim() : ""
  if (!s) return ""

  return s
    .split(/\s+/)
    .map((word) =>
      word
        .split("-")
        .map((part) => {
          if (!part) return part
          const c0 = part[0]
          if (!c0) return part
          return c0.toUpperCase() + part.slice(1).toLowerCase()
        })
        .join("-")
    )
    .join(" ")
}

/** Auth user first + last name for UI (empty when neither is set). */
export function userPersonNameFromAuth(
  user: { first_name?: string | null; last_name?: string | null } | null | undefined,
): string {
  return formatPersonName(
    [user?.first_name, user?.last_name]
      .map((s) => (typeof s === "string" ? s.trim() : ""))
      .filter(Boolean)
      .join(" "),
  )
}
